export default __webpack_public_path__ + "static/media/element_40.c6d20bb7.avif";